import React from "react";
import {
  IconButton,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";


export default function DialogDetails({
  open,
  onClose,
  justification
}) {


  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
    >
      <DialogTitle
        id="scroll-dialog-title"
        sx={{ position: "relative", textAlign: "center" }}
      >
        Justification
        <div className="absolute right-5 top-1/2 -translate-y-1/2">
          <IconButton
            aria-label="delete"
            size="small"
            sx={{
              backgroundColor: "muted.main",
            }}
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent dividers={true} sx={{ p: 0 }}>
        <DialogContentText
          id="scroll-dialog-description"
          tabIndex={-1}
        >
          <p className="p-4">{justification}</p>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
